import { TTrainStationType, TrainSHomeStoreCtx } from '@/stores/TrainStore/TrainSHomeStore';
import clsx from 'clsx';
import React, { useContext, useEffect, useRef, useState } from 'react';

import styles from './TrainSHomeStationDisplay.module.scss';

interface ITrainSHomeStationDisplayProps {
  stationType: TTrainStationType;
  station?: string;
}

const TrainSHomeStationDisplay: React.FC<ITrainSHomeStationDisplayProps> = ({ stationType, station }) => {
  const store = useContext(TrainSHomeStoreCtx);
  const stationRef = useRef<HTMLDivElement>(null);
  const [textZoom, setTextZoom] = useState(false);

  const label = store.getStationTypeLabel(stationType);

  useEffect(() => {
    if (process.browser && stationRef.current) {
      const screenWidth = window.innerWidth;
      const clientWidth = stationRef.current.clientWidth;
      const needTextZoom = (screenWidth <= 320 && clientWidth >= 95) || (screenWidth > 320 && clientWidth >= 122);

      setTextZoom(needTextZoom);
    }
  }, [station]);

  const stationClassName = clsx(styles.station, !station && styles.placeholder, textZoom && styles.textZoom);

  return (
    <button className={styles.container} onClick={() => store.onOpenStationModal(stationType)}>
      <div className={styles.label}>{label}</div>
      <div className={stationClassName} ref={stationRef}>
        {station || '선택'}
      </div>
    </button>
  );
};

export default TrainSHomeStationDisplay;
